import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = { class: "flex justify-between items-center mb-2" }
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = {
  key: 0,
  class: "svg-inline--fa fa-plus fa-w-14 text-white",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "plus",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "svg-inline--fa fa-check fa-w-14 text-white",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "check",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M438.6 132.5l-238 238.1c-9.3 9.3-24.4 9.3-33.7 0l-120-120c-9.3-9.3-9.3-24.4 0-33.7l28.6-28.6c9.3-9.3 24.4-9.3 33.7 0l84.3 84.3 204.6-204.6c9.3-9.3 24.4-9.3 33.7 0l28.6 28.6c9.2 9.3 9.2 24.4 0 33.7z"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex gap-2" }
const _hoisted_15 = { class: "py-2" }
const _hoisted_16 = { class: "py-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "w-full h-20 rounded-md",
  name: "remark"
}, null, -1)

import { useStore } from 'vuex';
import ToolsUpload from '../../tools/Upload.vue'
import ExampleTicketToolTip from './tooltip/ExampleTicketTooltip.vue'
import ToolsInputMobile from '../../tools/InputMobile.vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BetNotSettled',
  setup(__props) {

const provider = ref('');
const gameRound = ref('');
const userAlias = ref('');
const gameId = ref('');
const store = useStore();
const iconState = ref('plus');
const clicked = ref(false);

const getExampleImage = () => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/ticket-example/รูปตัวอย่าง ตรวจสอบรายการไม่จบเดิมพัน.png`
}

const convertGameRound = () => {
  const lines = gameRound.value.trim().split('\n');
  let providerGameRound = '';
  let gameIds: string[] = [];
  let alias = '';
  
  lines.forEach(line => {
    const trimmedLine = line.trim();
    if (trimmedLine) {
      if (!providerGameRound) {
        const providerList = JSON.parse(`${process.env.VUE_APP_PROVIDER_NAME}`).find((provider: any) => {
          if (provider.value == trimmedLine) {
            return provider.value;
          }
        });
        providerGameRound = providerList ? providerList.name : trimmedLine;
      } else if (trimmedLine.startsWith('Game Id:')) {
        const gameId: string = trimmedLine.split('Game Id:')[1].trim();
        if (!gameIds.includes(gameId)) {
          gameIds.push(gameId);
        }
      } else if (trimmedLine.startsWith('Alias:')) {
        alias = trimmedLine.split('Alias:')[1].trim();
      } else if (trimmedLine.startsWith('รหัสเกม:')) {
        const gameId: string = trimmedLine.split('รหัสเกม:')[1].trim();
        if (!gameIds.includes(gameId)) {
          gameIds.push(gameId);
        }
      } else if (trimmedLine.startsWith('ชื่อเล่น:')) {
        alias = trimmedLine.split('ชื่อเล่น:')[1].trim();
      }
    }
  });

  gameId.value = gameIds.join(',');
  userAlias.value = alias;
  provider.value = providerGameRound;
  if (gameId.value && userAlias.value && provider.value) {
    toggleIcon()
  }
};

const toggleIcon = () => {
  iconState.value = iconState.value === 'plus' ? 'check' : 'plus';
  clicked.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.operatorName')) + " ", 1),
        _createVNode(ExampleTicketToolTip, {
          image: getExampleImage()
        }, null, 8, ["image"])
      ]),
      _withDirectives(_createElementVNode("input", {
        name: "game_id",
        type: "text",
        class: "w-full rounded-md hidden",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((gameId).value = $event))
      }, null, 512), [
        [_vModelText, gameId.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        name: "provider_name",
        type: "text",
        class: "w-full rounded-md hidden",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((provider).value = $event))
      }, null, 512), [
        [_vModelText, provider.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        name: "user_alias",
        type: "text",
        class: "w-full rounded-md hidden",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userAlias).value = $event))
      }, null, 512), [
        [_vModelText, userAlias.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        value: _unref(store).state.selectedOperator.name,
        name: "operator_name",
        type: "text",
        class: "w-full rounded-md",
        disabled: true
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.gameRound')), 1),
        _createElementVNode("button", {
          type: "button",
          onClick: convertGameRound,
          class: _normalizeClass(['w-5 h-5 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-3 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:col-start-2 sm:text-sm', { 'bg-green-500': clicked.value, 'bg-blue-500': !clicked.value }])
        }, [
          (iconState.value === 'plus')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
            : (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("textarea", {
          type: "text",
          class: "w-full rounded-md",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((gameRound).value = $event)),
          rows: "7"
        }, null, 512), [
          [_vModelText, gameRound.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.customerUsername')) + " ", 1),
      _createVNode(ToolsInputMobile, { name: "username" })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.remark')) + " ", 1),
      _hoisted_17
    ]),
    _createVNode(ToolsUpload)
  ], 64))
}
}

})